export default __webpack_public_path__ + "995a5c79eaa02bf96bcd3c5d722b7c7f.png";